const errors = {
    generic: 'エラーが発生しました',
    notFound: 'ページが見つかりません',
    accessDenied: 'アクセス権限がありません',
    accessDeniedReason: {
      admin: 'このページの表示には管理者権限が必要です。',
      role: 'このページを表示できる権限が付与されていません。',
      permission: 'このページの表示に必要な権限が不足しています。',
    },
    accessDeniedContact: 'アクセスが必要な場合は、管理者にお問い合わせください。',
    pageNotFoundDescription: 'お探しのページは存在しないか、移動されました。',
    unauthorized: '権限がありません',
    forbidden: 'アクセスが拒否されました',
    serverError: 'サーバーエラーが発生しました',
    networkError: 'ネットワークエラーが発生しました',
    authenticationRequired: '認証が必要です。再度ログインしてください。',
    rateLimitExceeded: 'リクエストが多すぎます。しばらく時間をおいて再度お試しください。',
  };

export default errors;
